"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spacer = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
// eslint-disable-next-line
var react_1 = require("@emotion/react");
var mona_1 = require("@artegeie/design-system/mona");
var Spacer = function (_a) {
    var _b = _a.spacer, spacer = _b === void 0 ? mona_1.noneSpacer : _b, _c = _a.direction, direction = _c === void 0 ? 'bottom' : _c, children = _a.children;
    return (0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (Array.isArray(direction) ? direction : [direction]).map(function (d) { return "margin-".concat(d, ": ").concat(spacer); }).join(';')) }, { children: children }), void 0);
};
exports.Spacer = Spacer;
exports.default = exports.Spacer;
var templateObject_1;
